exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-address-add[data-v-36572a98] {\n  width: 100%;\n  margin-top: -20px;\n}\n.page-address-add .address-btn[data-v-36572a98] {\n  width: 94%;\n  margin: 0 auto;\n}\n", ""]);

// exports
